.nav {
  font-family: var(--nexus-font-sans);
  font-size: var(--nexus-text-sm);
}

.list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--nexus-space-xs);
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  display: flex;
  align-items: center;
  gap: var(--nexus-space-xs);
  min-width: 0;
}

.label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* A competition name can be long; a crumb truncates rather than wrapping the
     trail onto a second line. */
  max-width: 28ch;
}

.link a {
  color: var(--nexus-text-muted);
  text-decoration: none;
  transition: color var(--nexus-transition-fast);
}

.link a:hover,
.link a:focus-visible {
  color: var(--nexus-text);
  text-decoration: underline;
}

.current {
  color: var(--nexus-text);
  font-weight: var(--nexus-weight-medium);
}

.separator {
  color: var(--nexus-text-muted);
  user-select: none;
}
